/* Initializes the wishlist functions by fetching the list and adding event listeners. */
const init = swat => {
  let lists = fetchList(swat);

  if(!window.swymSelectedListId) createList(swat);

  addSwymEventListener(swat);
};

/* Fetches the wishlist data. */
const fetchList = async swat => {
  return new Promise((resolve, reject) => {
    const onSuccess = lists => {
      console.log("Fetched all Lists", lists);

      window.swymWishLists = lists;
      window.swymSelectedListId = lists && lists[0] && lists[0].lid;

      resolve(lists);

      updateButtonState();
    };

    const onError = error => {
      console.log("Error while fetching all Lists", error);

      reject(error);
    };

    if (!window.swymWishLists) {
      swat.fetchLists({
        callbackFn: onSuccess,
        errorFn: onError
      });
    } else {
      resolve(window.swymWishLists);
    }
  });
};

/* Create a new wishlist if not already exist. */
const createList = swat => {
  let listConfig = { "lname": "My Wishlist" };

  let onSuccess = function({ lid }) {
    console.log("Successfully created a new List", lid);

    window.swymSelectedListId = lid;
  }

  let onError = function(error) {
    console.log("Error while creating a List", error);
  }

  swat.createList(listConfig, onSuccess, onError);
}

/* Refreshes the wishlist by fetching the list again in the global scope. */
const refreshList = async swat => {
  window.swymWishLists = null;

  await fetchList(swat);
};

/* Adds product to wishlist action. */
const addToWishlist = (swat, product) => {

  async function fetchProductByVariantId(variantId) {
    let item = null;
    let page = 1;
    let hasMoreProducts = true;

    while (hasMoreProducts && !item) {
      try {
        const response = await fetch(`/products.json?limit=250&page=${page}`);
        const data = await response.json();
        if (data.products.length === 0) {
          hasMoreProducts = false;
        } else {
          item = data.products.find(p => p.variants.some(v => v.id.toString() === variantId));
          page++;
        }
      } catch (error) {
        console.error('Error fetching products:', error);
        hasMoreProducts = false;
      }
    }
    return item;
  }

  fetchProductByVariantId(product.epi).then(item => {
    if (item) {
      let sh_event_data = {
        item: item,
        store_currency: Shopify.currency.active
      };
        Shopify.analytics.publish('leaf_product_added_to_wishlist', sh_event_data);
    } else {
      console.log(`No product found for variant ID ${product.epi}`);
    }
  });

  let onSuccess = async function (addedListItem){
    console.log('Product has been added to wishlist!', addedListItem);
  }

  let onError = function (error){
    swat.ui.showErrorNotification({ message: "Error Adding Product to Wishlist" });
  }

  let lid = window.swymSelectedListId;

  swat.addToList(lid, product, onSuccess, onError);
  window.dataLayer.push({ "event": "add_to_wishlist" });
}

/* Remove product from wishlist action. */
const removeFromWishlist = (swat, product) => {
  let onSuccess = async function(deletedProduct) {
    console.log('Product has been removed from wishlist!', deletedProduct);
  }

  let onError = function() {
    swat.ui.showErrorNotification({ message: window.wishlistStrings.error });
  }

  let lid = window.swymSelectedListId;

  swat.deleteFromList(lid, product, onSuccess, onError);
}

/* Updates the state of wishlist buttons based on whether items are wishlisted. */
const updateButtonState = () => {
  const swymWishlistButtons = document.querySelectorAll('swymcs-wishlist-button');

  if (swymWishlistButtons) {
    swymWishlistButtons.forEach(swymWishlistButton => {
      const button = swymWishlistButton.querySelector('.swym-button');
      const { epi, empi } = button.dataset;

      let isWishlisted = false;

      if (window.swymWishLists) {
        window.swymWishLists.forEach(list => {
          list.listcontents.forEach(item => {
            if (item.empi == empi && item.epi == epi) {
              isWishlisted = true;
            }
          });
        });

        updateButtonWishlistState(button, isWishlisted);
      }
    });
  }
};

/* Updates the display state of a wishlist button based on whether the item is wishlisted. */
const updateButtonWishlistState = (button, isWishlisted) => {
  isWishlisted
    ? button.classList.add('swym-added')
    : button.classList.remove('swym-added');
};

/* Fetches product data from shopify to get updated data. */
const fetchProductsData = async url => {
  const productData = await fetch(`${url}.js`);

  if (productData.status === 404 || !productData.ok) return null;

  return await productData.json();
};

/* Adds event listeners for wishlist actions. */
const addSwymEventListener = swat => {
  swat.evtLayer.addEventListener(swat.JSEvents.removedFromWishlist, event => {
    let image = event.detail.d.iu;
    let title = event.detail.d.dt;

    showCustomNotification(swat, image, title, 'remove');
    refreshList(swat);
  });

  swat.evtLayer.addEventListener(swat.JSEvents.addedToWishlist, event => {
    let image = event.detail.d.iu;
    let title = event.detail.d.dt;

    showCustomNotification(swat, image, title, 'add');
    refreshList(swat);
  });

  swat.evtLayer.addEventListener(swat.JSEvents.variantChanged, data => {
    const currentVariant = data.detail.d.variant.id;
    const currentProductId = data.detail.d.product.id;
    const swymCustomWishlistButton = document.querySelector(`.swymcs-wishlist-button-${currentProductId}`);

    if (swymCustomWishlistButton) {
      swymCustomWishlistButton.setAttribute('data-epi', currentVariant);
    }

    setTimeout(updateButtonState, 200);
  });
};

const showCustomNotification = (swat, image, title, action) => {
  const text = window.wishlistStrings[action === 'remove' ? 'removed' : 'added'];
  const successMessage = `
      <div
        class="swym-custom-notification-content"
        onclick="_swat.ui.open()">
        <div class="swym-custom-image-container">
          <img
            class="swym-custom-image"
            src="${ image }"
            alt="wishlisted product image"/>
        </div>
        <div class="swym-custom-title-container">
          <strong>${ title }</strong> ${ text }
        </div>
      </div>
    `;

  swat.ui.showSuccessNotification({ message: successMessage });
}

/* Creating a global object to assign functions */
const swymcsWishlistFunctions = {
  init,
  fetchList,
  refreshList,
  updateButtonState,
  updateButtonWishlistState,
  addToWishlist,
  removeFromWishlist,
  addSwymEventListener,
  fetchProductsData,
  showCustomNotification
};

/* Push the init functions into SwymCallbacks  */
if (!window.SwymCallbacks) {
  window.SwymCallbacks = [];
}
window.SwymCallbacks.push(swymcsWishlistFunctions.init);

/* Expose swymcsWishlistFunctions to the global scope */
window.swymcsWishlistFunctions = swymcsWishlistFunctions;